<template>
    <CardPage :section="9" :page="15" :next="nextScreen">
        <p>
            <span class="font-weight-bold">
                And… BTW, we have some great resources to support adherence to PrEP for HIV prevention and ART for treatment of HIV.
            </span>
        </p>
        <p>
            Are you interested in more resources for adherence to PrEP for HIV prevention or ART for HIV treatment?
        </p>
        <v-layout row wrap justify-center my-3>
            <v-flex xs6>
                <div @click.prevent="viewPrep()" class="diagram-chip fact">
                    <v-chip color="primary" text-color="white" class="py-2" v-ripple>PrEP Resources</v-chip>
                    <div class="check" v-if="prepVisited">
                        <v-avatar class="success">
                            <v-icon dark>check</v-icon>
                        </v-avatar>
                    </div>
                </div>
                <div @click.prevent="viewArt()" class="diagram-chip fact">
                    <v-chip color="primary" text-color="white" class="py-2" v-ripple>ART Resources</v-chip>
                    <div class="check" v-if="artVisited">
                        <v-avatar class="success">
                            <v-icon dark>check</v-icon>
                        </v-avatar>
                    </div>
                </div>
            </v-flex>
        </v-layout>
    </CardPage>
</template>

<script>
import { get } from 'vuex-pathify';
import router from '@/router';

export default {
    data() {
        return {
            selectedFact: null
        };
    },
    computed: {
        prepVisited: get('section9/prepVisited'),
        artVisited: get('section9/artVisited'),
        finalScreen: get('section9/finalScreen'),
        firstPrepScreen: get('section9/firstPrepScreen'),
        firstArtScreen: get('section9/firstArtScreen'),
        nextScreen() {
            // if the user clicks the next button, jump to the end
            return `/page/9/${this.finalScreen}`;
        }
    },
    methods: {
        viewPrep() {
            // go to the first PrEP Adherence screen
            router.push(`/page/9/${this.firstPrepScreen}`);
        },
        viewArt() {
            // go to the first ART Adherence screen
            router.push(`/page/9/${this.firstArtScreen}`);
        }
    }
};
</script>

<style scoped>
.fact {
    position: relative;
}
.check {
    position: absolute;
    top: 50%;
    left: 0;
    transform: translate(-50%, -50%);
}
.visited {
    opacity: 0.5;
}
</style>
